export default "__VITE_ASSET__rYXHv6jE__"